export default __webpack_public_path__ + "static/newspaperro-5440c216d964f17aa7c592915e0c163e.png";